const MIN_AMOUNT = 0;

const getElementWidthAndMargin = (element: HTMLDivElement) => {
    const elementStyle = window.getComputedStyle(element);

    return element.offsetWidth + parseFloat(elementStyle.marginLeft) + parseFloat(elementStyle.marginRight);
};

const getMinMaxElements = (scrollContainerEl: HTMLDivElement, containerWidth: number) => {
    // eslint-disable-next-line no-undef
    const containerTranslateValue = Math.abs(new WebKitCSSMatrix(window.getComputedStyle(scrollContainerEl).transform).m41);

    let elementMinLeft: HTMLDivElement | null = null;
    let elementMaxLeft: HTMLDivElement | null = null;

    const elements = scrollContainerEl.children;

    for (let index = 0; index < elements.length; index++) {
        const element = elements[index] as HTMLDivElement;
        const elementOffsetLeft = element.offsetLeft;

        if (
            elementOffsetLeft + getElementWidthAndMargin(element) >= containerTranslateValue
            && elementOffsetLeft <= containerWidth + containerTranslateValue
        ) {
            if (!elementMinLeft || !elementMaxLeft) {
                elementMinLeft = element;
                elementMaxLeft = element;

                continue;
            }

            if (elementMinLeft.offsetLeft >= elementOffsetLeft) {
                elementMinLeft = element;
            }

            if (elementMaxLeft.offsetLeft <= elementOffsetLeft) {
                elementMaxLeft = element;
            }
        }
    }

    return {
        elementMinLeft,
        elementMaxLeft
    };
};

export const calculateScroll = (containerEl: HTMLDivElement, scrollContainerEl: HTMLDivElement, isLeftScroll: boolean) => {
    const containerWidth = containerEl.offsetWidth;
    const { elementMinLeft, elementMaxLeft } = getMinMaxElements(scrollContainerEl, containerWidth);

    if (!elementMinLeft || !elementMaxLeft) {
        return 0;
    }

    let transformAmount = isLeftScroll
        ? elementMinLeft.offsetLeft + elementMinLeft.offsetWidth - containerWidth
        : elementMaxLeft.offsetLeft;

    if (elementMinLeft === elementMaxLeft) {
        const elementWidth = getElementWidthAndMargin(elementMaxLeft);
        transformAmount += isLeftScroll ? -elementWidth : elementWidth;
    }

    return Math.max(transformAmount, MIN_AMOUNT);
};
